import { store } from '@/redux/store';
import { openedDrawerSelector } from '@/redux/drawer/drawer.selectors';
import type { DeprecatedDrawerName, DrawerName } from 'minerva-plugin-api';
import { closeDrawer } from '@/redux/drawer/drawer.slice';
import { closeLegend } from '@/services/pluginsManager/legend/closeLegend';

export const hidePanel = (panelName: DrawerName | DeprecatedDrawerName | undefined): void => {
  const { getState, dispatch } = store;
  const drawerName = openedDrawerSelector(getState());

  /** the legend is an overlay rather than a drawer panel, v21 routed it through hidePanel */
  if (panelName === 'legend') {
    closeLegend();
    return;
  }

  /** an alias of 'available-plugins', v21 accepted both names for the plugins panel */
  const name = panelName === 'plugins' ? 'available-plugins' : panelName;

  /** 'none' was a redux sentinel duplicating the undefined that already means "closed" */
  if (name === drawerName || name === undefined || name === 'none') {
    dispatch(closeDrawer());
  }
};
